import React from "react";
import { NumericFormat } from "react-number-format";
import { FormattedMessage } from "react-intl";
import moment from "moment/moment";

export const getTicketStatusDescription = (ticketStatus) => {
  switch (ticketStatus) {
    case "1":
      return <FormattedMessage id="ticketsGrid.ticketStatus1"/>
    case "0":
      return <FormattedMessage id="ticketsGrid.ticketStatus0"/>
    case "2":
      return <FormattedMessage id="ticketsGrid.ticketStatus2"/>
    default:
      return ticketStatus
  }
};

export const formatDate = (dateStr, locale) => {
  if (!locale) return "-";
  const date = moment(dateStr);
  return date.isValid() ? date.locale(locale.split("_")[0]).format("DD MMM YYYY") : "-";
};

export const renderAmount = (value) => (
  <NumericFormat
    value={value}
    thousandSeparator=","
    decimalScale={2}
    fixedDecimalScale
    displayType="text"
    renderText={(val) => <div>{val}</div>}
  />
);
